Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAMP;
// REVIEWERS: clay-schubiner

// Returns whether the page is an amp page or not. 'process.env.AMP' will be replaced by
// webpack on compile-time with 'true' or 'false'
function isAMP() {
  return process.env.AMP;
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/isAmp.js
// module id = 253
// module chunks = 168707334958949